import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AsyncReactSelect from "react-select/async";

const AsyncSelect = props => {
	const {
		className,
		id,
		ariaLabel,
		ariaLabelledBy,
		placeholder,
		menuPlacement,
		value,
		defaultValue,
		autoFocus,
		isDisabled,
		isMulti,
		isClearable,
		name,
		loadOptions,
		noOptionsMessage,
		onChange,
		onInputChange,
		onMenuClose,
		dataTestId,
	} = props;

	return (
		<div data-test-id={dataTestId}>
			<AsyncReactSelect
				className={classNames(className, "async-select")}
				classNamePrefix="react-select"
				inputId={id}
				menuPlacement={menuPlacement}
				autoFocus={autoFocus}
				isDisabled={isDisabled}
				isMulti={isMulti}
				isClearable={isClearable}
				placeholder={placeholder}
				name={name}
				value={value}
				defaultValue={defaultValue}
				loadOptions={loadOptions}
				onChange={onChange}
				noOptionsMessage={noOptionsMessage}
				onInputChange={onInputChange}
				onMenuClose={onMenuClose}
				aria-label={ariaLabel}
				aria-labelledby={ariaLabelledBy}
			/>
		</div>
	);
};

AsyncSelect.propTypes = {
	name: PropTypes.string,
	className: PropTypes.string,
	id: PropTypes.string,
	ariaLabel: PropTypes.string,
	ariaLabelledBy: PropTypes.string,
	placeholder: PropTypes.string,
	menuPlacement: PropTypes.oneOf(["bottom", "top", "auto"]),
	value: PropTypes.any,
	defaultValue: PropTypes.any,
	autoFocus: PropTypes.bool,
	isDisabled: PropTypes.bool,
	isMulti: PropTypes.bool,
	isClearable: PropTypes.bool,
	loadOptions: PropTypes.func,
	noOptionsMessage: PropTypes.func,
	onInputChange: PropTypes.func,
	onChange: PropTypes.func,
	onMenuClose: PropTypes.func,
	dataTestId: PropTypes.string,
};

AsyncSelect.defaultProps = {
	name: "",
	className: undefined,
	id: undefined,
	ariaLabel: undefined,
	ariaLabelledBy: undefined,
	placeholder: "Select...",
	menuPlacement: undefined,
	value: undefined,
	defaultValue: null,
	autoFocus: false,
	isDisabled: false,
	isMulti: false,
	isClearable: false,
	loadOptions: () => {},
	noOptionsMessage: () => "No results",
	onInputChange: () => {},
	onChange: () => {},
	onMenuClose: () => {},
	dataTestId: undefined,
};

export default AsyncSelect;
